import { Button } from '@dashboard/ui'
import { useTranslation } from 'react-i18next'

export const DangerousAction = (props: { onClick: () => void; btnText: string; title: string }) => {
  const { t } = useTranslation()
  return (
    <div className="flex w-full items-center gap-4 rounded-md bg-fg-error-tertiary p-3">
      <div>
        <div className="font-semibold text-text-error-secondary">{t('danger-zone')}</div>
        <div className="text-text-error-secondary">{props.title}</div>
      </div>
      <Button color="danger" variant="outline" onClick={props.onClick} className="ml-auto">
        {props.btnText}
      </Button>
    </div>
  )
}
